import { Controller } from "@hotwired/stimulus"

// Bootstrap's dropdown-menu is positioned by Popper.js using the "absolute"
// strategy by default -- coordinates computed relative to the nearest
// positioned ancestor, in document space (includes scroll offset). CSS
// alone (e.g. a .position-fixed override on the menu) can't fix a menu
// that needs to escape a clipping/stacking ancestor: it reinterprets
// Popper's already-computed absolute-space numbers as viewport-space,
// which only happens to line up when the page is scrolled to the top --
// scroll down first and the menu opens off by exactly the scroll offset.
//
// Passing popperConfig as a function (rather than a plain object) merges
// with Bootstrap's own defaults instead of replacing them, so modifiers
// like "flip" are kept. Creating the Dropdown instance here, before any
// click, means Bootstrap's own click-delegated init (getOrCreateInstance)
// reuses this instance instead of creating a fresh default one.
export default class extends Controller {
  connect() {
    new window.bootstrap.Dropdown(this.element, {
      popperConfig: (defaultConfig) => ({ ...defaultConfig, strategy: "fixed" }),
    })
  }
}
